/** @format */

import { HomrAudiences } from '@shared/data-access/interfaces';
import { HomrTemplateContent } from './homr-template-content.interface';
import { IRequestContext } from './request-context.interface';

export interface ContentScheduleMetaObject {
  csid?: string;
  label?: string;
  startDate?: string;
  endDate?: string;
  contentType?: string;
  audience?: string;
  promoId?: string;
  promoLoggedIn?: number;
}
export interface HomrPage<TTemplate extends string = string> {
  audience: string;
  metaDescription?: string;
  pageTitle?: string;
  staticId?: string;
  templateName: TTemplate;
  templateTag: string;
  tsid: string;
  content: HomrTemplateContent<TTemplate>;
  contentScheduleMeta: Record<string, ContentScheduleMetaObject>;
  requestContext?: IRequestContext;
  audienceAnalytics?: HomrAudiences[];
  sku?: string;
}

export type HomrResponse = HomrPage | HomrPage[] | null;
